import { Dialog } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: theme.customShape.borderRadiusXLarge,
    boxShadow: '0px 144px 250px 0px rgba(221, 253, 108, 0.2)',
  },
}));
